import { render, staticRenderFns } from "./DoubleAuctionMarketSingle.vue?vue&type=template&id=2659a52a"
import script from "./DoubleAuctionMarketSingle.vue?vue&type=script&lang=js"
export * from "./DoubleAuctionMarketSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports